module.exports = __webpack_public_path__ + "img/elite_honey_ba_list.f1cd4bd0.jpg";